/**
 * Detect platform subdomain hosts (acme.coursolo.ai), excluding reserved labels.
 * Custom domains are not detected here — use branding API `tenant: true`.
 */
export function isLikelyPlatformTenantHost(hostname) {
    const host = String(hostname || '').replace(/^www\./, '').replace(/:\d+$/, '').toLowerCase();
    const root = String(process.env.REACT_APP_PLATFORM_ROOT_DOMAIN || 'coursolo.ai')
        .replace(/^www\./, '')
        .toLowerCase();
    if (!host || host === 'localhost' || host === '127.0.0.1') return false;
    if (host === root) return false;
    if (host.endsWith('.vercel.app')) return false;
    if (host.endsWith(`.${root}`)) {
        const slug = host.slice(0, -(root.length + 1)).split('.')[0];
        return Boolean(slug && !['www', 'api', 'admin', 'app', 'saas'].includes(slug));
    }
    if (host.endsWith('.localhost')) {
        const slug = host.split('.')[0];
        return Boolean(slug && !['www', 'api', 'admin', 'app', 'saas'].includes(slug));
    }
    return false;
}

export function platformTenantSlug(hostname) {
    if (!isLikelyPlatformTenantHost(hostname)) return null;
    return String(hostname || '').replace(/^www\./, '').replace(/:\d+$/, '').split('.')[0] || null;
}
